/** @typedef {{[key:string]: ContentStatus}} ContentStatusEnum */
/** @type {ContentStatusEnum} */
export const CONTENT_STATUS = {
  archived: 'archived',
  online: 'online',
  published: 'published',
};
/**
 * @callback GetTranslationFromContent Sort the Content translations by their IDs
 * @param {Content} content
 * @param {string} localeId
 * @returns {ContentTranslation}
 */
/** @type {GetTranslationFromContent} */
export const getTranslationFromContent = (content, localeId) => content.translations
  .find((translation) => translation.localeId === localeId);
/**
 * @callback getContentStatusUIConfig Get UI Définition of a content by its status
 * @param {ContentStatus} status
 * @returns {{color: string, label: string}}
 */
/** @type {getContentStatusUIConfig} */
export const getContentStatusUIConfig = (status) => {
  const config = {
    [CONTENT_STATUS.archived]: {
      color: 'alert100',
      label: `cortizol.contentStatus.${CONTENT_STATUS.archived}`,
    },
    [CONTENT_STATUS.online]: {
      color: 'success100',
      label: `cortizol.contentStatus.${CONTENT_STATUS.online}`,
    },
    [CONTENT_STATUS.published]: {
      color: 'success100',
      label: `cortizol.contentStatus.${CONTENT_STATUS.online}`,
    },
  };

  return config[status];
};
